module.exports = __webpack_public_path__ + "static/media/wtof-3.61473dfc.png";